/**
 * Shopify inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  SHOPIFY_EVENT_CATEGORIES,
  SHOPIFY_EVENT_METADATA,
} from './supported-events'

export const SHOPIFY_SIGNING_SECRET_MIN_LENGTH = 16

export const shopifyInboundPresenter: InboundProviderPresenter = {
  providerId: 'shopify',
  displayName: 'Shopify',
  categories: SHOPIFY_EVENT_CATEGORIES,
  events: SHOPIFY_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `shopify:${orgId}:${brandId}:${eventType}`
  },
}
